module.exports = __webpack_public_path__ + "img/profile.c3d52c93.svg";